import { Loader2 } from "lucide-react";
import { Button } from "../ui/button";
import {
  PILL_FILLED_CLASS,
  PILL_OUTLINE_CLASS,
} from "./CancelSubscriptionDialog";
import { formatPrice } from "./formatters";

export interface InvoicePaymentStepProps {
  amount: number;
  currency: string;
  pending?: boolean;
  onPay: () => void;
  onClose: () => void;
}

export function InvoicePaymentStep({
  amount,
  currency,
  pending = false,
  onPay,
  onClose,
}: InvoicePaymentStepProps) {
  const symbol = currency === "USD" ? "$" : "";
  const label = `PAY CANCELLATION FEES - ${symbol}${formatPrice(amount)}${symbol ? "" : ` ${currency}`}`;

  return (
    <div className="tw:flex tw:flex-col tw:gap-4 tw:py-2">
      {/* <p
        className="tw:text-base tw:font-semibold tw:text-center tw:m-0"
        style={{ color: "var(--so-text, #523D33)" }}
      >
        Pay to cancel subscription
      </p> */}
      <p
        className="tw:text-sm tw:m-0 tw:mx-auto"
        style={{ color: "var(--so-text, #523D33)" }}
      >
        You will be navigated to checkout page to pay the difference amount,
        your subscription will be cancelled right after the payment.
      </p>
      <div className="tw:flex tw:flex-col tw:gap-2 tw:pt-2">
        <Button
          type="button"
          disabled={pending}
          onClick={onClose}
          className={PILL_FILLED_CLASS}
        >
          Keep subscription{" "}
        </Button>
        <Button
          type="button"
          disabled={pending}
          variant="outline"
          onClick={onPay}
          className={PILL_OUTLINE_CLASS}
        >
          {pending ? (
            <Loader2 className="tw:size-4 tw:animate-spin tw:mx-auto" />
          ) : (
            label
          )}
        </Button>
      </div>
    </div>
  );
}
